import { IssuePriority, TodoIssueRecord } from '@/entities/issue';
import { dataNameProp } from '@/ui/helpers';
import { TagType } from '@/ui/components/Tag';
import { IssueStatus } from '@/entities/todo';

export const useIssue = () => {
  const hasAssignees = (issue: TodoIssueRecord) => issue.data.assignees.length > 0
    || issue.data.associateAssignees.length > 0
    || issue.data.issue.assignedGroups.length > 0;

  const joinAssignees = (issue: TodoIssueRecord) => [
    ...issue.data.issue.assignedGroups.map(i => i.data.title),
    ...issue.data.assignees.map(dataNameProp),
    ...issue.data.associateAssignees.map(aa => aa.email),
  ].join(', ');

  const priorityToTagType: { [key in IssuePriority]: TagType } = {
    //remove when we are sure it is not in DB
    [IssuePriority.Low]: 'neutral',
    [IssuePriority.Normal]: 'neutral',
    [IssuePriority.High]: 'error',
  };

  const issueStatusToTagType: { [key in IssueStatus]: TagType } = {
    [IssueStatus.Pending]: 'primary',
    [IssueStatus.InProgress]: 'warning',
    [IssueStatus.Done]: 'success',
    [IssueStatus.CantDo]: 'neutral',
  };

  return {
    hasAssignees,
    joinAssignees,
    priorityToTagType,
    issueStatusToTagType,
  };
};
